"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.dynamicListings.name': 'Dynamiczne Oferty',
    'tools.dynamicListings.description': 'Wyświetla panel z ofertami dopasowanymi do kontekstu rozmowy, gdy spełniony zostanie określony warunek',
};
